import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { chatClient } from "@core/clients";
import { OrderChat } from "@core/types";
import { orderChatQueryKeys } from "./keys";
import { ORDER_CHAT_STALE_TIME_MS } from "./constants";

type Options = Omit<UseQueryOptions<OrderChat | null>, "queryKey" | "queryFn">;

const useOrderChatQuery = (orderId: number | undefined, options?: Options) =>
  useQuery<OrderChat | null>({
    queryKey: orderChatQueryKeys.byOrder(orderId ?? 0),
    queryFn: () =>
      chatClient.getOrCreateOrderChat(orderId as number, {
        create: false,
      }),
    enabled: !!orderId,
    staleTime: ORDER_CHAT_STALE_TIME_MS,
    ...options,
  });

export default useOrderChatQuery;
